import React, { useEffect } from 'react';
import { GlobalLogger } from '@bbkAdminUtils/GlobalLogger';
import { useLocation } from '@bbkShared/react-router';

export const NotFoundPage = () => {
  const location = useLocation();

  useEffect(() => {
    GlobalLogger.error(`Could not find page ${location.pathname}`);
  }, []);

  return <>Page is not found</>;
};
